import React from "react";
import BlogThirtySeven from "../component/BlogThirtySeven";

function BlogThirtySevenContainer() {
  return <BlogThirtySeven />;
}

export default BlogThirtySevenContainer;
